import React from 'react';
import styled from 'styled-components';
import { object } from 'prop-types';
import { BodyText } from 'library/components/text-elements/text';
import TableCellTooltip from 'library/components/data-table/components/table-cell-tooltip';

const StyledActionsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  position: relative;
`;

const TextColumnComponent = ({ record }) => {
  const datum = record.email;
  if (datum && datum.length > 21) {
    return (
      <StyledActionsContainer>
        <TableCellTooltip activeOnHover tip={datum}>
          <div>{datum?.substring(0, 18) + '...'}</div>
        </TableCellTooltip>
      </StyledActionsContainer>
    );
  }
  return <BodyText>{datum}</BodyText>;
};

TextColumnComponent.propTypes = {
  record: object,
};

export default TextColumnComponent;
